/********************************************************
* Auth Module
*
* numerous helper functions to allow easier authentication
* 
* !! No DOM touching allowed in this module dude !!
********************************************************/


// requirements
var $ = require('jquery') // would be nice to remove this
var ds = require('Modules/data_store');



/**********************************************
 Variable Declarations
**********************************************/

// define module object to be exported
var m = {};



/**********************************************
 Private Functions
**********************************************/

// Default Parameter check and assign
def_param = function(arg, def) { return (typeof arg == 'undefined' ? def : arg); }

// retrieve token data from data_store
getSessionData = function() { return ds.get( 'token' ); }



 /**********************************************
 Public Functions
**********************************************/

m.login = function(method, api_url, data, headers) {
    headers = def_param(headers, null);

    return $.ajax({
        type: method,
        url: api_url,
        headers: headers,
        data: data
    }).fail(function(jqXHR, textStatus, errorThrown) {

        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);

    }).pipe(function( json ) {
        data = JSON.parse(json);
        
        if (data.success && data.token) {
            ds.set('token', data.token);

            var token = data.token
            var token_array = token.split('.');
            ds.set('token_header', JSON.parse(atob(token_array[0])) );
            ds.set('token_payload', JSON.parse(atob(token_array[1])) );
        }
        
        return data;
    });
}


m.verify = function(api_url) {
    var sessionData = getSessionData();
    return m.login('POST', api_url, null, {'Authorization' : sessionData})
}

m.logout = function() {
    ds.clear();
    //var sessionData = m.getSessionData();
    //return m.login('POST', 'api_auth/logout', null, {'Authorization' : sessionData})
}


m.checkSessionStore = function() {
    var sessionData = getSessionData(); 

    if ((sessionData != null) && (sessionData != "")) {
        //console.log('cookie LIVES!')
        return true;
    }
    else return false;
}





// export module
module.exports = m;